import { render, staticRenderFns } from "./DefaultCell.vue?vue&type=template&id=20eb0b78&"
import script from "./DefaultCell.vue?vue&type=script&lang=ts&"
export * from "./DefaultCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports